module.exports = __webpack_public_path__ + "img/cp10_02.f01abcc8.jpg";